const BUBBLE_COLORS = ['#3d88f2', '#8f98b3', '#45b0e6', '#56bf68', '#e89800', '#b00008', '#184050', '#9161f3', '#e85050', '#30a050'];

export const getBubbleColor = (name: string): string => {
    const colorIndex = name.length % BUBBLE_COLORS.length;

    return BUBBLE_COLORS[colorIndex];
};
